export default __webpack_public_path__ + "static/media/fifaimage.e5242b5a.jpg";